import { Button } from '@components/Button'
import { IProductPage } from '@dtos/ProductPage'
import { useRudderstack } from '@hooks/useAnalytics'
import { useThemeParams } from '@hooks/useThemeParams'
import { navigateTo } from './helpers'

export type BuyButtonLocation = 'hero' | 'aside' | 'footer' | 'mobile_bar'

interface IBuyButtonProps {
  label: string
  url: string | null
  location: BuyButtonLocation
  product: IProductPage
  fullWidth?: boolean
}

// Adblock ou falha de rede seguram o onFlush para sempre; o teto garante que
// a ida ao checkout nunca fica presa esperando o tracking.
const FLUSH_TIMEOUT_MS = 400

// CTA de compra: Button padrão do members na variant cta (cor cherry da
// paleta, como o %button_big_tertiary do hero_theme).
export function BuyButton({
  label,
  url,
  location,
  product,
  fullWidth = false,
}: IBuyButtonProps) {
  const { track } = useRudderstack()
  const { data: themeParams } = useThemeParams()

  if (!url) return null

  const handlePress = () => {
    let navigated = false
    const goToCheckout = () => {
      if (navigated) return
      navigated = true
      navigateTo(url)
    }

    track(
      'Sales Page Buy Button Clicked',
      {
        location,
        school_id: themeParams?.school?.id,
        product_id: product.id,
        product_name: product.title ?? undefined,
        product_type: product.course?.kind ?? product.kind ?? undefined,
      },
      goToCheckout,
    )
    setTimeout(goToCheckout, FLUSH_TIMEOUT_MS)
  }

  return (
    <Button
      variant="cta"
      size="large"
      testID="product-buy-button"
      width={fullWidth ? '100%' : 345}
      maxWidth="100%"
      onPress={handlePress}
    >
      {label}
    </Button>
  )
}
